var exports = {
  "kL": "BottomCTASection.module__container___WlBhaT",
  "DD": "BottomCTASection.module__title___WlBhaT",
  "UD": "BottomCTASection.module__buttonContainer___WlBhaT",
  "x6": "BottomCTASection.module__button___WlBhaT",
};

module.exports = exports;
